<template>
  <div
    class="grid gap-4 text-center"
    :class="[
      tool.isLast ? 'col-span-3 sm:col-span-1' : '',
      tool.isFirst ? '' : 'sm:pt-6',
    ]"
  >
    <div class="flex items-center justify-center">
      <component :is="tool.icon" :size="40" :stroke-width="1.1" />
    </div>
    <h3 class="text-[14px] font-semibold leading-none">
      {{ tool.title }}
    </h3>
    <p
      class="text-[14px] font-medium"
      :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
      v-html="tool.description"
    ></p>
    <RouterLink
      :to="{ name: tool.link }"
      class="flex items-center justify-center gap-2 text-[14px] font-semibold capitalize leading-none text-primary-100"
    >
      {{ tool.linkText }}
      <MoveRight :size="16" :stroke-width="1.75" />
    </RouterLink>
  </div>
</template>

<script>
import { MoveRight } from "lucide-vue-next";

export default {
  name: "ToolCard",
  props: {
    mode: String,
    tool: {
      type: Object,
      default: () => ({
        title: "",
        description: "",
        icon: null,
        link: "",
        linkText: "",
        isLast: false,
        isFirst: false,
      }),
    },
  },
  components: {
    MoveRight,
  },
};
</script>
